var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/Calendar-Empty"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon Color",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5 0C4.75313 0 4.96233 0.188103 4.99544 0.432153L5 0.5V2H11V0.5C11 0.223858 11.2239 0 11.5 0C11.7531 0 11.9623 0.188103 11.9954 0.432153L12 0.5V2H14.5C15.3284 2 16 2.67157 16 3.5V6.5V14.5C16 15.3284 15.3284 16 14.5 16H1.5C0.671573 16 0 15.3284 0 14.5V6.5V3.5C0 2.67157 0.671573 2 1.5 2H4V0.5C4 0.223858 4.22386 0 4.5 0ZM11 3V4L11.0046 4.06785C11.0377 4.3119 11.2469 4.5 11.5 4.5C11.7761 4.5 12 4.27614 12 4V3H14.5C14.7761 3 15 3.22386 15 3.5V6H1V3.5C1 3.22386 1.22386 3 1.5 3H4V4L4.00456 4.06785C4.03767 4.3119 4.24687 4.5 4.5 4.5C4.77614 4.5 5 4.27614 5 4V3H11ZM1 7H15V14.5C15 14.7761 14.7761 15 14.5 15H1.5C1.22386 15 1 14.7761 1 14.5V7Z",
    fill: "#888B8D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarEmpty);
export default __webpack_public_path__ + "static/media/Calendar-Empty.789a07f1750add2d595aed65bd885f64.svg";
export { ForwardRef as ReactComponent };